import Text from "./text";
import Image from "./../image";

interface WarningTextProps {
  title: string;
  description?: string;
}

const WarningText: React.FC<WarningTextProps> = ({ title, description }) => {
  return (
    <div className="flex justify-center">
      <div className="flex flex-col max-w-[353px] warning-box">
        <div className="flex items-start gap-2 mb-[13px]">
          <div><Image
            aria-hidden
            src="/assets/icon_warning.png"
            alt="warning icon"
            width={24}
            height={24}
          /></div>
          <Text text={title} />
        </div>
        {description && <Text className="text-sm" size={13} text={description} />}
      </div>
    </div>
  );
};

export default WarningText;
